import { render, staticRenderFns } from "./RaterPricesTables.vue?vue&type=template&id=4407fc0a&"
import script from "./RaterPricesTables.vue?vue&type=script&lang=js&"
export * from "./RaterPricesTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports